<template>
  <v-container class="df">
    <!-- <Navbar /> -->
    <v-card class="elevation-12">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Crea una contraseña segura</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon>mdi-lock</v-icon>
      </v-toolbar>
      <v-form v-model="valid" @submit.prevent="confirmAccount">
        <v-card-text>
          <v-text-field
            id="password"
            label="Password"
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            counter
            @click:append="show = !show"
            :rules="[rules.required, rules.min]"
            :error="!!error"
            @keyup="error = null"
          ></v-text-field>
          <PasswordIndicator :pass="password" />

          <v-text-field
            id="confirm"
            label="Confirm password"
            v-model="confirmPass"
            type="password"
            :rules="[
              rules.required,
              rules.match(this.password, this.confirmPass),
            ]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <p v-if="error">{{ error }}</p>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit" :disabled="!valid">Crear</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { API } from "../globals";
import Navbar from "./smartchronos/partials/Navbar";
import { apiv1 } from "@/libs/apiv1";
import PasswordIndicator from "./PasswordIndicator";

export default Vue.extend({
  name: "SetPassword",
  components: {
    PasswordIndicator,
    Navbar,
  },
  data: () => ({
    error: null,
    password: "",
    confirmPass: "",
    show: false,
    valid: false,
    rules: {
      required: (value) => !!value || "Por favor diligencie este campo",
      min: (v) => v.length >= 8 || "Min 8 characters",
      match: (pass, confirm) =>
        pass === confirm || "Las contraseñas deben coincidir",
    },
  }),
  methods: {
    confirmAccount: function () {
      const { token } = this.$route.params;
      const { type } = this.$route.query;

      console.log(token, type);
      axios({
        url: `${process.env.VUE_APP_BACKEND}/set-password/${token}?type=${type}`,
        method: "PUT",
        data: { pass: this.confirmPass },
      })
        .then((res) => {
          this.$awn.success(res.data);
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err.response);
          this.error = err.response.data;
          /* this.$awn.alert(err.response.data);
          this.$router.push("/"); */
        });
    },
  },
});
</script>
<style lang="scss" scoped>
.df {
  width: 100%;
  margin-top: -800px;
}
</style>
